import { useState } from "react";
import {
    Box,
    IconButton,
    Drawer,
    useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";

import Sidebar from "./SideBar";
import ChatWindow from "./ChatWindow";

export default function ChatUI(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [openSidebar, setOpenSidebar] = useState(false);

    return (
        <Box display="flex" height="100vh" bgcolor="#343541">
            {
                isMobile ?
                    <Drawer
                        anchor="left"
                        open={openSidebar}
                        onClose={() => setOpenSidebar(false)}
                        PaperProps={{
                            sx: {
                                width: 260,
                                bgcolor: "#202123",
                            },
                        }}
                    >
                        <Sidebar chats={props.chats} activeChat={props.activeChat} onNewChat={props.onNewChat} ChatSessionList={props.ChatSessionList} onSelectChat={props.onSelectChat} activeChatId={props.activeChatId} />
                    </Drawer>
                    :
                    <Sidebar chats={props.chats} activeChat={props.activeChat} onNewChat={props.onNewChat} ChatSessionList={props.ChatSessionList} onSelectChat={props.onSelectChat} activeChatId={props.activeChatId} />
            }

            {
                isMobile ?
                    <Box
                       // display="flex"
                        alignItems="center"
                        px={1}
                        py={1}
                        borderBottom="1px solid #444"
                        bgcolor="#343541"
                    >
                        <IconButton
                            onClick={() => setOpenSidebar(true)}
                            sx={{ color: "#ECECF1" }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                    :
                    null
            }

            <ChatWindow {...props} />
        </Box>
    );
}
